import { z } from 'zod';

export const grupoEconomicoSchema = z
  .object({
    id: z.coerce.number(),
    nome: z.string(),
    cnpj: z.string().nullish(),
    observacoes: z.string().nullish(),
    created_at: z.string().nullish(),
    updated_at: z.string().nullish(),
    clientes_count: z.coerce.number().default(0),
    imoveis_count: z.coerce.number().default(0),
    area_total_ha: z.coerce.number().default(0),
  })
  .passthrough();
export type GrupoEconomico = z.infer<typeof grupoEconomicoSchema>;

export const gruposEconomicosListSchema = z.array(grupoEconomicoSchema);

export const grupoEconomicoCreateSchema = z.object({
  nome: z.string().min(1, 'Nome é obrigatório'),
  cnpj: z.string().nullish(),
  observacoes: z.string().nullish(),
});
export type GrupoEconomicoCreateInput = z.infer<typeof grupoEconomicoCreateSchema>;

export const grupoEconomicoUpdateSchema = grupoEconomicoCreateSchema.partial();
export type GrupoEconomicoUpdateInput = z.infer<typeof grupoEconomicoUpdateSchema>;
